var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InviteTeam',{attrs:{"groupID":_vm.$route.params.groupID,"type":"convidar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }